import { useState } from "react";
import { supabase } from "./supabase";

const US_STATES = ["AL","AK","AZ","AR","CA","CO","CT","DE","FL","GA","HI","ID","IL","IN","IA","KS","KY","LA","ME","MD","MA","MI","MN","MS","MO","MT","NE","NV","NH","NJ","NM","NY","NC","ND","OH","OK","OR","PA","RI","SC","SD","TN","TX","UT","VT","VA","WA","WV","WI","WY"];

export default function Auth({ onLogin }) {
  const [mode, setMode] = useState("login");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [name, setName] = useState("");
  const [zip, setZip] = useState("");
  const [state, setState] = useState("");
  const [newsletter, setNewsletter] = useState(false);
  const [msg, setMsg] = useState("");
  const [loading, setLoading] = useState(false);

  const handle = async () => {
    if (!email || !password) return setMsg("Please fill in all fields.");
    setLoading(true);
    setMsg("");

    if (mode === "register") {
      const { error } = await supabase.auth.signUp({
        email,
        password,
        options: {
          data: {
            full_name: name,
            newsletter_opt_in: newsletter,
            zip_code: zip,
            state,
          },
        },
      });
      if (error) { setMsg(error.message); setLoading(false); return; }
      setMsg("✅ Check your email to confirm your account!");
    } else {
      const { data, error } = await supabase.auth.signInWithPassword({ email, password });
      if (error) { setMsg(error.message); setLoading(false); return; }
      onLogin(data.user);
    }
    setLoading(false);
  };

  return (
    <div style={{ maxWidth: 400, margin: "60px auto", padding: 32, border: "1px solid #e5e7eb", borderRadius: 16, background: "white", boxShadow: "0 4px 24px #0001", fontFamily: "system-ui, sans-serif" }}>
      <h2 style={{ margin: "0 0 4px", fontSize: 22, fontWeight: 700 }}>{mode === "login" ? "Sign in" : "Create account"}</h2>
      <p style={{ margin: "0 0 20px", color: "#6b7280", fontSize: 14 }}>One Last Cast</p>

      {mode === "register" && (
        <input placeholder="Full name" value={name} onChange={e => setName(e.target.value)}
          style={{ width: "100%", padding: "9px 12px", border: "1px solid #d1d5db", borderRadius: 8, fontSize: 14, boxSizing: "border-box", marginBottom: 10 }} />
      )}

      <input placeholder="Email" value={email} onChange={e => setEmail(e.target.value)}
        style={{ width: "100%", padding: "9px 12px", border: "1px solid #d1d5db", borderRadius: 8, fontSize: 14, boxSizing: "border-box", marginBottom: 10 }} />

      <input placeholder="Password" type="password" value={password} onChange={e => setPassword(e.target.value)}
        style={{ width: "100%", padding: "9px 12px", border: "1px solid #d1d5db", borderRadius: 8, fontSize: 14, boxSizing: "border-box", marginBottom: 10 }} />

      {mode === "register" && (
        <>
          <div style={{ display: "flex", gap: 8, marginBottom: 10 }}>
            <select value={state} onChange={e => setState(e.target.value)}
              style={{ flex: 1, padding: "9px 12px", border: "1px solid #d1d5db", borderRadius: 8, fontSize: 14, color: state ? "#111" : "#9ca3af" }}>
              <option value="">State</option>
              {US_STATES.map(s => <option key={s} value={s}>{s}</option>)}
            </select>
            <input placeholder="Zip code" value={zip} onChange={e => setZip(e.target.value)} maxLength={5}
              style={{ flex: 1, padding: "9px 12px", border: "1px solid #d1d5db", borderRadius: 8, fontSize: 14, boxSizing: "border-box" }} />
          </div>
          <label style={{ display: "flex", alignItems: "center", gap: 8, fontSize: 13, color: "#374151", marginBottom: 18, cursor: "pointer" }}>
            <input type="checkbox" checked={newsletter} onChange={e => setNewsletter(e.target.checked)} />
            Subscribe to product updates &amp; newsletter
          </label>
        </>
      )}

      {msg && (
        <p style={{ fontSize: 13, color: msg.startsWith("✅") ? "#16a34a" : "#dc2626", marginBottom: 12 }}>{msg}</p>
      )}

      <button onClick={handle} disabled={loading}
        style={{ width: "100%", padding: 10, background: "#2563eb", color: "white", border: "none", borderRadius: 8, fontWeight: 600, fontSize: 15, cursor: "pointer", marginBottom: 12, opacity: loading ? 0.7 : 1 }}>
        {loading ? "Please wait..." : mode === "login" ? "Sign in" : "Create account"}
      </button>

      <p style={{ textAlign: "center", fontSize: 13, color: "#6b7280" }}>
        {mode === "login" ? "No account?" : "Already registered?"}{" "}
        <span onClick={() => { setMode(mode === "login" ? "register" : "login"); setMsg(""); }}
          style={{ color: "#2563eb", cursor: "pointer", fontWeight: 600 }}>
          {mode === "login" ? "Sign up" : "Sign in"}
        </span>
      </p>
    </div>
  );
}